import { render } from "./WizardComponent.vue?vue&type=template&id=6f1ad3ff&scoped=true"
import script from "./WizardComponent.vue?vue&type=script&lang=js"
export * from "./WizardComponent.vue?vue&type=script&lang=js"

import "./WizardComponent.vue?vue&type=style&index=0&id=6f1ad3ff&scoped=true&lang=css"
import "./WizardComponent.vue?vue&type=style&index=1&id=6f1ad3ff&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f1ad3ff"]])

export default __exports__